module.exports = __webpack_public_path__ + "img/duplicate-scan-label-en.b5ffb6bd.svg";